import React, { useEffect, useMemo, useState } from 'react';
import MainContainer from './MainContainer';
import ErrorBoundary from './ErrorBoundary';
import { Provider, lightTheme, darkTheme, View } from '@adobe/react-spectrum';
import LeftRail from './LeftRail';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from '@react-spectrum/toast';
import MainContainerProvider from './mainContainerProvider';
import { useAppProvider } from './applicationProvider';
import Cookies from 'js-cookie';
import { Loggedin } from './globalContant';
import { ThemeProvider as CustomThemeProvider } from './themeContext';
import { ThemeProvider as MaterialUIThemeProvider, createTheme } from '@mui/material/styles';

const App: React.FC = () => {
  const [colorScheme, setColorScheme] = useState<'light' | 'dark'>('light');
  const loggedIn = Cookies.get('loggedin');
  const { loggedinState } = useAppProvider();
  useEffect(() => {
    const getInitialTheme = () => {
      const hour = new Date().getHours();
      // Use dark theme between 6 PM and 6 AM
      return hour >= 18 || hour < 6 ? 'dark' : 'light';
    };

    setColorScheme(getInitialTheme());

    // Optional: update every hour
    const interval = setInterval(() => {
      setColorScheme(getInitialTheme());
    }, 1000 * 60 * 60); // every hour

    return () => clearInterval(interval);
  }, []);
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: colorScheme,
          background: {
            default: colorScheme === 'dark' ? '#202020' : '#F5F5F5',
          },
          text: {
            primary: colorScheme === 'dark' ? '#fff' : '#000',
          },
        },
      }),
    [colorScheme]
  );
  return (
    <View data-theme={colorScheme}>
      <MaterialUIThemeProvider theme={theme}>
        <CustomThemeProvider value={colorScheme}>
          <BrowserRouter>
            <Provider theme={colorScheme === 'dark' ? darkTheme : lightTheme} colorScheme={colorScheme}>
              <ToastContainer />
              <ErrorBoundary>
                {loggedIn === Loggedin.SUCCESS || loggedinState ? (
                  <MainContainerProvider>
                    <LeftRail setColorScheme={setColorScheme} colorScheme={colorScheme}>
                      <MainContainer />
                    </LeftRail>
                  </MainContainerProvider>
                ) : (
                  <MainContainerProvider>
                    <MainContainer />
                  </MainContainerProvider>
                )}
              </ErrorBoundary>
            </Provider>
          </BrowserRouter>
        </CustomThemeProvider>
      </MaterialUIThemeProvider>
    </View>
  );
};

export default App;
